import { To } from 'react-router-dom'

import { P, match } from 'ts-pattern'

import { useAppSelector } from '~/app/hooks'

export const prepareToProps = (to: To, navHide: boolean): To => {
  if (!navHide) {
    return to
  }

  return match(to)
    .with(P.string, (to) => `${to}${to.includes('?') ? '&' : '?'}navhide=1`)
    .otherwise((to) => ({
      ...to,
      search: `${to.search ?? ''}&navhide=1`,
    }))
}

export const usePrepareToProps = (to: To): To =>
  prepareToProps(
    to,
    useAppSelector((state) => state.Ui.navHide)
  )
